import { HttpHandler } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {LoginHandlingSevice} from '@itmc/ngx-oidcclient';
import {Observable, catchError, of, switchMap} from 'rxjs';
import {environment} from 'src/environments/environment';
import {AttendeesService} from './attendees.service';
import {GeneralconfigService} from './generalconfig.service';
import {RoomService} from './room.service';
import {TimeslotService} from './timeslot.service';
import {TimetableEntryService} from './timetable-entry.service';
import {TagsService} from './tags.service';

@Injectable({
  providedIn: 'root'
})
export class MiniBookAdminService extends LoginHandlingSevice {

  #attendees: AttendeesService;
  #generalConfig: GeneralconfigService;
  #rooms: RoomService;
  #tags: TagsService;
  #timeslots: TimeslotService;
  #timetableEntries: TimetableEntryService;

  tenant: string = '';

  override appInitialize(): Observable<any> {
    return super.appInitialize().pipe(
      switchMap(() => this.login()),
      catchError(error => {
        console.log('Login MiniBookAdminService failed', error);
        return of(false);
      })
    )
  }

  constructor(httpHandler: HttpHandler) {
    super(environment.url, httpHandler);
    this.#attendees = new AttendeesService(this.httpClient, this);
    this.#generalConfig = new GeneralconfigService(this.httpClient, this);
    this.#rooms = new RoomService(this.httpClient, this);
    this.#tags = new TagsService(this.httpClient, this);
    this.#timeslots = new TimeslotService(this.httpClient, this);
    this.#timetableEntries = new TimetableEntryService(this.httpClient, this);
  }

  get attendees() {
    return this.#attendees
  }

  get generalConfig() {
    return this.#generalConfig;
  }

  get rooms() {
    return this.#rooms;
  }

  get tags(){
    return this.#tags;
  }

  get timeslots() {
    return this.#timeslots;
  }

  get timetableEntries() {
    return this.#timetableEntries;
  }
}
